// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"509":"73455a9e","903":"83d3d7c4"}[chunkId] + ".chunk.js";
};